import { useTranslation } from "react-i18next";
import { buildChipMeta } from "./chipMeta";
import { ProductChip } from "./ProductChip";
import { ProductName } from "./ProductName";
import type { WindowEntryLayoutProps } from "./types";

export function WindowEntryDesktop({
    entry,
    preview,
    readonly,
    onRemoveChip,
}: WindowEntryLayoutProps) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center gap-4">
            {preview}

            <div className="flex-1 min-w-0 flex flex-col justify-center gap-3">
                {entry.chips.map((chip) => (
                    <ProductName
                        key={`${chip.category}:${chip.typeId}`}
                        name={chip.productName}
                        meta={buildChipMeta(chip, t)}
                        withTestIds
                    />
                ))}
            </div>

            <div className="flex flex-col justify-center gap-3 shrink-0">
                {entry.chips.map((chip) =>
                    readonly ? (
                        <ProductChip
                            key={`${chip.category}:${chip.typeId}`}
                            chip={chip}
                            readonly
                        />
                    ) : (
                        <ProductChip
                            key={`${chip.category}:${chip.typeId}`}
                            chip={chip}
                            onRemove={() => onRemoveChip?.(chip)}
                        />
                    ),
                )}
            </div>
        </div>
    );
}
